<template>
    <v-chip v-if="label" :color="severity === 'critical' ? 'error' : 'warning'" :size="size" variant="flat"
            class="font-weight-bold flex-shrink-0">
        {{ label }}
    </v-chip>
</template>

<script setup>
import {computed} from 'vue';
import {alertSeverity, severityLabel} from '@/composables/alertTypes';

const props = defineProps({
    alert: {type: Object, required: true},
    size: {type: String, default: 'x-small'},
});

const severity = computed(() => alertSeverity(props.alert));
const label = computed(() => severityLabel(severity.value));
</script>
